var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgTransfer = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.87.25a.599.599 0 0 1 .49.262.62.62 0 0 1 .108.35v2.072l4.054-.01a.59.59 0 0 1 .422.18.619.619 0 0 1-.192.997.585.585 0 0 1-.228.046l-4.654.011a.591.591 0 0 1-.551-.377.624.624 0 0 1-.046-.234V2.509l-3.26 3.877 3.26 3.71V8.982c0-.162.063-.317.175-.432a.59.59 0 0 1 .422-.18h6.033V6.276c0-.124.037-.245.106-.348a.585.585 0 0 1 .94-.056l4.653 5.414a.62.62 0 0 1 0 .807l-4.654 5.449a.595.595 0 0 1-.657.17.6.6 0 0 1-.282-.223.622.622 0 0 1-.106-.349v-2.096H7.846a.59.59 0 0 1-.422-.179.62.62 0 0 1 0-.864.59.59 0 0 1 .422-.18H12.5a.59.59 0 0 1 .422.18c.112.114.175.27.175.432v1.08l3.262-3.82-3.262-3.795v1.087a.619.619 0 0 1-.175.432.59.59 0 0 1-.422.18H6.468v2.094a.62.62 0 0 1-.105.346.585.585 0 0 1-.936.062L.772 6.805a.62.62 0 0 1-.009-.808L5.418.461A.598.598 0 0 1 5.87.25Z",
  fill: "currentColor"
})));

export default SvgTransfer;